import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../../initialState";

const conciergeWidgetSlice = createSlice({
  name: "conciergeWidget",
  initialState: initialState.conciergeWidget,
  reducers: {
    openConciergeWidget(state) {
      return { ...state, isOpen: true };
    },
    closeConciergeWidget(state) {
      return { ...state, isOpen: false, isMaximized: false };
    },
    toggleConciergeWidget(state) {
      return { ...state, isOpen: !state.isOpen };
    },
    setMaximized(state, action: { payload: boolean }) {
      return { ...state, isMaximized: action.payload };
    },
  },
});

export const {
  openConciergeWidget,
  closeConciergeWidget,
  toggleConciergeWidget,
  setMaximized,
} = conciergeWidgetSlice.actions;

export type ConciergeWidgetState = ReturnType<
  typeof conciergeWidgetSlice.reducer
>;

export default conciergeWidgetSlice.reducer;
